import {
  AccessRestrictions,
  Identifiable,
  Planzone,
  RestrictedAreas,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";

function serializeRestrictions(restrictions: AccessRestrictions): {
  [key: string]: string;
} {
  const restrictedAreas: RestrictedAreas[] = [
    "personalSynthesis",
    "personalTimesheet",
    "resources",
    "costProfiles",
    "projectTemplates",
    "projectReportsTemplate",
    "projectStatuses",
    "portfolios",
    "calendar",
    "strategicAxes",
    "exports",
    "onlyOffice",
    "documents",
  ];

  return restrictedAreas.reduce(
    (nextRestrictions, area) =>
      restrictions[area]
        ? {
            ...nextRestrictions,
            [`restrictions.${area}`]: restrictions[area].join(","),
          }
        : nextRestrictions,
    {},
  );
}

function updateAccessRestrictions(httpClient: HttpClient) {
  return (
    { uuid }: Identifiable<Planzone>,
    restrictions: AccessRestrictions,
    nextRestrictions: AccessRestrictions,
  ) =>
    httpClient
      .sendHttpRequest<Identifiable<Planzone>>({
        endpoint: `/planzones/${uuid}`,
        method: HttpMethods.GET,
      })
      .then(({ settings }) =>
        httpClient.sendHttpRequest<void>({
          endpoint: `/planzones/${uuid}`,
          method: HttpMethods.PATCH,
          data: {
            settings: {
              ...settings,
              ...serializeRestrictions(nextRestrictions),
            },
          },
        }),
      );
}

export { updateAccessRestrictions };
